export default {
  GET_MONITORING_OBJECT: state => state.newChartValue,
  GET_COMPANY_OBJECT: state => state.company_object,
  getObjectsMap: state => state.objectsMap,
  GET_POLLUTION_SOURCE_LIST: state => state.pollutionSources,
  GET_SELECT_OBJECT_SOURCES_LIST: state => state.pollutionSourcesSelectList,
  GET_SELECT_POLLUTION_SOURCE_NORMATIVE_LIST: state => state.selectPollutionSourcesList,
  GET_POLLUTION_SOURCE_NORMATIVE_CHART: state => state.pollutionSourceNormativeCharts,
  GET_SELECT_LIST: state => state.setSelectList
}
